import { Box, Typography } from '@mui/material';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';

import PartProductsViewerModal from './PartProductsViewerModal/PartProductsViewerModal';
import PartsCounter from './PartsCounter/PartsCounter';

const ShelfAndPartMap = props => {
  const {
    loading,
    areaGuid,
    shelfsData,
    isViewerModalOpen,
    onClickPart,
    closeViewerModal,
    partDisplay,
    arrangedRows,
    arrangedRowsLoading,
    onSelectCell,
  } = props;

  if (!areaGuid) {
    return (
      <Box sx={{ w: 'full', pt: 4, textAlign: 'center' }}>
        لطفا یک ناحیه را انتخاب کنید
      </Box>
    );
  }

  if (loading) {
    return <SpinnerLoader />;
  }

  return (
    <>
      <Box sx={{ width: '100%' }}>
        {shelfsData
          ? shelfsData?.map(shelf => (
              <Box
                key={shelf.guid}
                sx={{
                  mt: 2,
                  mb: 7,
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    padding: '10px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '5px',
                  }}
                >
                  <Typography sx={{ fontWeight: 'bold', fontSize: 18 }}>
                    {shelf?.display}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: 2,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    flexWrap: 'wrap',
                    gap: '14px',
                  }}
                >
                  {shelf?.parts?.length
                    ? shelf.parts?.map(part => (
                        <PartsCounter
                          key={part.guid}
                          isFull={part.isFull}
                          status={part.status}
                          cellCount={part.cellCount}
                          productCellCount={part.productCellCount}
                          emptyCellCount={part.emptyCellCount}
                          title={part.display}
                          onClick={() => onClickPart(part.guid)}
                        />
                      ))
                    : null}
                </Box>
              </Box>
            ))
          : null}
      </Box>
      <PartProductsViewerModal
        show={isViewerModalOpen}
        closeHandler={closeViewerModal}
        partDisplay={partDisplay}
        arrangedRows={arrangedRows}
        loading={arrangedRowsLoading}
        onSelectCell={onSelectCell}
      />
    </>
  );
};

export default ShelfAndPartMap;
